<template>
  <div class="contact-main">
    <zone-header :companyId="companyId" :id="id" class="home-head"></zone-header>
    <zone-carousel :carouselList="carouselList" class="main-carousel"></zone-carousel>
    <div class="main-content">
      <div class="content-info left">
        <div class="content-info-head">
            <div class="content-info-image left">
              <img src="">
            </div>
          <div class="content-info-title left">
            <span>联系方式</span>
          </div>
        </div>
        <div>
            <span></span>
        </div>
      </div>
      <div class="main-contact left">
        <zone-contact></zone-contact>
      </div>
    </div>
    <zone-footer class="left"></zone-footer>
  </div>

</template>

<script>
import ZoneFooter from "./zone-footer";
import zoneHeader from "./zone-header";
import ZoneCarousel from "./zone-carousel";
import ZoneContact from "./zone-contact";
export default {
  name: "zone-maincontact",
  components:{
    ZoneContact,
    ZoneCarousel,
    ZoneFooter,
    zoneHeader
  },
  created() {
    this.headCompanyId = this.$route.query.companyId;
    this.headId = this.$route.query.id;
    this.headLogo = this.$route.query.headLogo;
    this.id = this.$route.query.id;
    if (this.companyId == null || this.companyId == "") {
      this.isCompany = false;
    }
    this.selectPromotionList("link", "link", "linkList");
    /*初始化轮播图*/
    this.selectPromotionList("carousel", "carousel", "carouselList");
  },
  data() {
    return {
      entityBuyer: {},
      companyId: "",
      id: "",
      headCompanyId: "",
      headLogo: "",
      headId: "",
      carouselList: []
    };
  },
  methods: {
    /*查询推广列表*/
    selectPromotionList: function (modelId, entityName, entityListName) {
      var that = this;
      that.$http.get(that.base + "/category/get.do", {
        params: {
          modelId: modelId
        }
      }).then(function (data) {
        that[entityName] = data.data.result;
        var categoryId = data.data.result.id;
        that.$http.get(that.base + "/promotion/list.do", {
          params: {
            categoryId: categoryId,
            id: that.companyId
          }
        }).then(function (data) {
          that.zhuanquSize = data.data.result.length;
          for (var i = 0; i < data.data.result.length; i++) {
            if (data.data.result[i].imagesUrl != null && data.data.result[i].imagesUrl != "") {
              data.data.result[i].imagesUrl = JSON.parse(data.data.result[i].imagesUrl);
            }
            if (data.data.result[i].categoryId == categoryId && data.data.result[i].id == that.headCompanyId) {
              that.entityBuyer = data.data.result[i];
              if (data.data.result[i].imagesUrl != null && data.data.result[i].imagesUrl != "") {
                that.entityBuyer.imagesUrl = data.data.result[i].imagesUrl[0].url;
              }
            }
          }
          that[entityListName] = data.data.result;
        }).catch(function (error) {

        })
      }).catch(function (error) {

      })
    },
    getParameter: function (paraName) {
      var url = document.location.toString();
      if (url.lastIndexOf('#') == (url.length - 1)) {
        url = url.substring(0, url.lastIndexOf('#'));
      }
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
  }
}
</script>

<style scoped>
.contact-main{
  width: 100%;
  margin: 0 auto;
}
.home-head{
  width: 100%;
  margin: 0 auto;
}
.main-content{
  height: 500px;
  width: 1160px;
  padding: 20px 0;
  margin: 0 auto;
}
.main-carousel{
  height: 279px !important;
  width: 1160px !important;
  margin: 0 auto;
}
.content-info{
  height: 100%;
  width: 745px;
  background-color: #FFFFFF;
}
.main-contact{
  margin-left: 20px;
  height: 350px;
}
.content-info-head{
  height: 15%;
  width: 100%;
  border-bottom: 1px solid #F2F2F2;
}
.content-info-image{
  width: 50px;
  height: 50px;
  margin: 10px 10px;
}
.content-info-title{
  font-size: 2rem;
  font-family: MicrosoftYaHei;
  padding:20px 0 0 20px;
  font-weight: bold;
}

@media (min-width: 992px) and (max-width: 1200px){
  .main-content{
    height: 500px;
    width: 960px;
    padding: 20px 0;
    margin: 0 auto;
  }
  .main-carousel{
    height: 279px !important;
    width: 960px !important;
    margin: 0 auto;
  }
  .content-info{
    height: 100%;
    width: 600px;
    background-color: #FFFFFF;
  }
  .main-contact{
    margin-left: 20px;
    height: 350px;
    width: 340px;
  }
  .content-info-head{
    height: 15%;
    width: 100%;
    border-bottom: 1px solid #F2F2F2;
  }
  .content-info-image{
    width: 50px;
    height: 50px;
    margin: 10px 10px;
  }
  .content-info-title{
    font-size: 2rem;
    font-family: MicrosoftYaHei;
    padding:20px 0 0 20px;
    font-weight: bold;
  }
}
@media (min-width: 768px) and (max-width: 992px){
  .main-content{
    height: 500px;
    width: 720px;
    padding: 20px 0;
    margin: 0 auto;
  }
  .main-carousel{
    height: 279px !important;
    width: 720px !important;
    margin: 0 auto;
  }
  .content-info{
    height: 100%;
    width: 470px;
    background-color: #FFFFFF;
  }
  .main-contact{
    margin-left: 20px;
    height: 250px;
    width: 230px;
  }
  .content-info-head{
    height: 14%;
    width: 100%;
    border-bottom: 1px solid #F2F2F2;
  }
  .content-info-image{
    width: 40px;
    height: 40px;
    margin: 5px 5px;
  }
  .content-info-title{
    font-size: 1.6rem;
    font-family: MicrosoftYaHei;
    padding:10px 0 0 10px;
    font-weight: bold;
  }
}
@media (max-width: 768px){
  .main-content{
    height: 400px;
    width: 100%;
    padding: 20px 0;
  }
  .content-info{
    height: 100%;
    width: 60%;
    background-color: #FFFFFF;
  }
  .main-contact{
    margin-left: 2%;
    height: 250px;
    width: 38%;
  }
  .content-info-head{
    height: 14%;
    width: 100%;
    border-bottom: 1px solid #F2F2F2;
  }
  .content-info-image{
    width: 30px;
    height: 30px;
    margin: 5px 5px;
  }
  .content-info-title{
    font-size: 1.4rem;
    font-family: MicrosoftYaHei;
    padding:5px 0 0 10px;
    font-weight: bold;
  }
  .main-carousel{
    height: 249px !important;
    width: 100% !important;
  }
}
</style>